import { getState } from 'live/redux/selectors/index.shared';
import get from 'lodash/get';
import { createSelector } from 'reselect';

const idSelector = (_, props) => props.id;
const getChat = createSelector(getState, state => get(state, 'chat'));
const getChatList = createSelector(getChat, chat => get(chat, 'list'));

export const getChatPage = createSelector(getChat, chat => get(chat, 'page'));

export const getChatListMessages = createSelector(getChatList, state =>
  get(state, 'messages'),
);

export const getChatMessageById = createSelector(
  [getChatListMessages, idSelector],
  (state, id) => state.find(m => m.id === id),
);

export const getChatListLoading = createSelector(getChatList, state =>
  get(state, 'loading'),
);

export const getChatListTotalPages = createSelector(getChatList, state =>
  get(state, 'totalPages'),
);

export const getChatListError = createSelector(getChatList, state =>
  get(state, 'error'),
);

export const getChatRecentUsers = createSelector(getChat, state =>
  get(state, 'recentUsers'),
);

// active message

export const getChatMessage = createSelector(getChat, chat =>
  get(chat, 'message'),
);

export const getChatMessageError = createSelector(getChatMessage, state =>
  get(state, 'error'),
);
